import { handleActions } from 'redux-actions'
import { Immutable as ImmutableGenericsType } from 'seamless-immutable'
import get from 'lodash/get'

import { initialState, NotificationState, NotificationSeverityEnum } from './model'
import { Payload } from '../../../types'
import { prepareActions } from '../../../utils/redux'

const actionsNames = ['showNotification', 'hideNotification', 'hideAllNotifications']

interface Actions {
  showNotification: any
  hideNotification: any
  hideAllNotifications: any
}

export const actions: Actions = prepareActions(actionsNames, 'notification') as Actions

type State = ImmutableGenericsType<NotificationState>

export default handleActions<State, Payload>(
  {
    [actions.showNotification]: (state, action): State => {
      const config: any = {
        ...action.payload,
      }

      if (!config.severity) {
        config.severity = NotificationSeverityEnum.Normal
      }

      const notificationId = get(action, 'id')

      return state.setIn([notificationId], config)
    },
    [actions.hideNotification]: (state, action): State => {
      if (action.payload) {
        const notificationId = action.payload.toString()

        return state.without(notificationId)
      }
      return state
    },
    [actions.hideAllNotifications]: (state): State => {
      const keys = Object.keys(state)

      let newState: any = state

      keys.forEach((key: string) => {
        newState = newState.without(key)
      })

      return newState
    },
  },
  initialState
)
